import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import './BackToTopButton.css';

const BackToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Throttle scroll events for better performance
        let throttleTimeout = null;

        const toggleVisibility = () => {
            if (throttleTimeout) return;

            throttleTimeout = setTimeout(() => {
                if (window.pageYOffset > 300) {
                    setIsVisible(true);
                } else {
                    setIsVisible(false);
                }
                throttleTimeout = null;
            }, 100);
        };

        window.addEventListener('scroll', toggleVisibility);
        
        // Check initial scroll position
        toggleVisibility();

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
            if (throttleTimeout) {
                clearTimeout(throttleTimeout);
            }
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <button
            className={`back-to-top-btn ${isVisible ? 'visible' : ''}`}
            onClick={scrollToTop}
            aria-label="Back to top"
            type="button"
        >
            <FontAwesomeIcon icon={faArrowUp} />
        </button>
    );
};

export default BackToTopButton;

